import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IMemberAchievements } from "./routeType";

import type { IPickMutation } from "@/api";
import { useGetAllMemberAchievements } from "@/api/members/achievements/getAll";
import { useGetMemberAchievement } from "@/api/members/achievements/get";
import { axiosClient, queryClient } from "@api/clients.ts";
import { getApi } from "@api/apiPath";

const { getPath } = getApi("members.achievements.put");

type IExtractedRouteType = IMemberAchievements["achievementSingleUpdate"];

export type IPutMemberAchievement = IPickMutation<IExtractedRouteType>;

const putMemberAchievement: MutationFunction<
  IPutMemberAchievement["response"],
  IPutMemberAchievement["variables"]
> = ({ memberId, achievementId, ...data }) => {
  return axiosClient.put(getPath({ memberId, achievementId }), data);
};

export const usePutMemberAchievement = createMutation({
  mutationFn: putMemberAchievement,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberAchievements.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberAchievement.getKey({ memberId }),
    });
  },
});
